import { Drawer, type DrawerProps } from "antd";
import { type ReactNode, useCallback } from "react";

import { useTracking } from "utilities/analytics/analytics";

export interface IBTDrawerProps
    extends Pick<
        DrawerProps,
        | "className"
        | "placement"
        | "visible"
        | "afterVisibleChange"
        | "forceRender"
        | "width"
        | "height"
        | "closable"
        | "onClose"
        | "mask"
        | "title"
        | "footer"
        | "destroyOnClose"
        | "keyboard"
        | "bodyStyle"
        | "push"
        | "getContainer"
        | "style"
        | "zIndex"
        | "contentWrapperStyle"
        | "drawerStyle"
    > {
    children: ReactNode;
    role?: React.AriaRole;
    /** Accessible name for the drawer, needed when it has no visible title of its own. */
    "aria-label"?: string;
}

export function BTDrawer({ children, visible, afterVisibleChange, ...otherProps }: IBTDrawerProps) {
    const { trackEvent, Track } = useTracking({
        element: "Drawer",
    });

    const handleVisibleChange = useCallback(() => {
        if (visible) {
            trackEvent({
                event: "DrawerOpen",
            });
        } else {
            trackEvent({
                event: "DrawerClose",
            });
        }
        afterVisibleChange?.(visible ? visible : false);
    }, [visible, trackEvent, afterVisibleChange]);

    return (
        <Track>
            {/* eslint-disable-next-line react/forbid-elements */}
            <Drawer afterVisibleChange={handleVisibleChange} visible={visible} {...otherProps}>
                {children}
            </Drawer>
        </Track>
    );
}
